module.exports = __webpack_public_path__ + "static/media/Max75stand.22f6d713.jpg";